import { render, staticRenderFns } from "./IcoDuplicate.vue?vue&type=template&id=14a1169b&scoped=true"
import script from "./IcoDuplicate.vue?vue&type=script&lang=js"
export * from "./IcoDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a1169b",
  null
  
)

export default component.exports